// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4908":"5d4424ce1ab48a17","9292":"70bffc73de12bc75"}[chunkId] + ".css";
};